import { DistributionImportsService } from '../../services/imports.service';
import { DistributionStatementService } from '../../services/statement.service';
import * as types from './types';
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
export const importsActions = {
  // async [types.ImportsList.FETCH.ALL]({ commit }, payload) {
  //   const {startDate,endDate}=payload
  //   const importsList = await DistributionImportsService.getSalesMatrixData(startDate,endDate);
  //   console.log({ "importsList": importsList });

  //   commit(types.ImportsList.SET.ALL, importsList.data);
  // },
    async [types.ImportsList.FETCH.ALL]({ commit,getters }, payload) {
      const { start, row_count, searchMode, basicFilter, searchFilter } = payload;
     console.log('aa',{ start, row_count, searchMode, basicFilter, searchFilter })
      let res;
      const { searchString, channel,startDate,endDate } = basicFilter;
      if (searchMode == 'none') {
        if (start == 0) {
          res = await DistributionImportsService.getSalesMatrixData(startDate,endDate,searchString,channel,start,row_count);
             commit(types.ImportsList.SET.ALL, res.data);
        } 
        
        else {
           res = await DistributionImportsService.getSalesMatrixData(startDate,endDate,searchString,channel,start,row_count);
      
          commit(types.ImportsList.SET.ALL, {
            ...getters.importsList,
            statement_settings: [
              ...getters.importsList?.statement_settings,
              ...res.data.statement_settings,
            ]
          });
  
          // Setting EOL
          if (!(res?.data?.statement_settings?.length > 0)) {
            return EOL_REACHED;
          }
        }
  
      } 
      
      else if (searchMode == 'basic') {
        const res = await DistributionImportsService.getSalesMatrixData(startDate,endDate,searchString,channel,start,row_count);
        if (start == 0) {
          commit(types.ImportsList.SET.ALL, {
            ...getters.importsList,
            statement_settings: res.data.statement_settings
          });
        } else {
          commit(types.ImportsList.SET.ALL, {
            ...getters.importsList,
            statement_settings: [
              ...getters.importsList?.statement_settings,
              ...res.data.statement_settings,
            ]
          });
        }
  
  
        // Setting EOL
        if (!(res?.data?.statement_settings?.length > 0)) {
          return EOL_REACHED;
        }
      }
  },
  async [types.SET_IMPORT_SENDER_RP_STATUS]({ commit, getters }, payload) {

    const { statement_setting_id, royalty_period_id, status } = payload;

    commit(types.ImportsList.SET.ALL, {
      ...getters.importsList,
      statement_settings: getters.importsList?.statement_settings?.map(st => {
        if (st.statement_setting_id == statement_setting_id) {
          return {
            ...st,
            sender_royalty_periods: st.sender_royalty_periods.map(rp => {
              if (rp.royalty_period_id == royalty_period_id) {
                return {
                  ...rp,
                  status,
                };
              } else {
                return rp;
              }
            })
          };
        } else {
          return st;
        }
      })
    });
  },
  async [types.ImportsList.DELETE.SINGLE]({ commit }, payload) {
    const { statement_id } = payload;
    commit(types.ImportsList.DELETE.SINGLE, payload)
    await DistributionStatementService.statementStatusInQueue(statement_id);
    await DistributionStatementService.deleteStatement(statement_id);

  },
  async [types.BasicFilter.SET.SINGLE]({ commit }, payload) {
    commit(types.BasicFilter.SET.SINGLE, payload)
  },
}